import React from 'react';
import {
  Stack,
} from '@mui/material';
import { ContextMenuComplete, formatTimeWithTimeZoneName, useCurrentTime } from '@marageti/z4-lib';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import DetailsCard from './DetailsCard';
import { getPhoneNumber } from '../../../utils/helpers';

type ContextMenuCompleteProps = Parameters<typeof ContextMenuComplete>[0];

type UserProfileProps = {
  countryCodes: CountryCodeMap;
  traveler: Traveler;
  contextMenuProps?: ContextMenuCompleteProps
};

const UserProfile = ({ countryCodes, traveler, contextMenuProps = undefined }: UserProfileProps) => {
  const [time] = useCurrentTime(traveler?.timeZone?.name);

  return (
    <Stack
      direction="column"
      spacing={3}
    >
      <DetailsCard
        items={[
          {
            title: 'First Name',
            content: traveler.givenName,
            // eslint-disable-next-line react/jsx-props-no-spreading
            action: contextMenuProps && <ContextMenuComplete {...contextMenuProps} />,
          },
          {
            title: 'Last Name ',
            content: traveler.familyName,
          },
          {
            title: 'Phone Number',
            content: getPhoneNumber(traveler),
          },
          {
            title: 'Country of Residence',
            content: countryCodes[traveler.countryOfResidence],
          },
          {
            title: 'Timezone',
            content: formatTimeWithTimeZoneName(traveler?.timeZone, time),
          },
        ]}
      />
    </Stack>
  );
};

export default UserProfile;
